// extracted by mini-css-extract-plugin
module.exports =  {"distance":"_93444fe79c--distance--vi8O9","icon":"_93444fe79c--icon--ExZ8p"};